import React from 'react';
import './HorizontalTabPanel.css';
import Tab from '../TabPanel/Tab';
import logComponent from '../../common/logComponent';

export default function HorizontalTabPanel({ updateCurrentPanel, children, tabTitle, currentPanel  }) {

  if (logComponent('HorizontalTabPanel')) { console.debug('Header HorizontalTabPanel'); }

  const selectPanel = (panelTitle) => {
    if (logComponent('HorizontalTabPanel')) { console.debug('Header selectPanel'); }
    updateCurrentPanel(panelTitle);
  }
  return (
    <div className="HorizontalTabPanel">
      <div className="HorizontalTabPanel__tab-container">
        <h4 className="HorizontalTabPanel__tab-heading"><span>{tabTitle}</span></h4>
        <ul className="HorizontalTabPanel__tabs">
          {children
            .filter(child => !child.props.hideIf)
            .map((child, index) =>
              <li
                className={'HorizontalTabPanel__tab' + (currentPanel === child.props.tabTitle ? ' HorizontalTabPanel__tab--selected' : '')}
                key={child.props.tabTitle}
              >
                <Tab
                  title={child.props.tabTitle}
                  linkPath={child.props.linkPath}
                  badge={child.props.tabBadge}
                  onButtonClick={selectPanel} />
              </li>
            )}
        </ul>
      </div>
      <div className="HorizontalTabPanel__panels">
        {children
          .filter(child => !child.props.hideIf)
          .map((child, index) =>
            <div
              className={'HorizontalTabPanel__panel' + (currentPanel === child.props.tabTitle ? ' HorizontalTabPanel__panel--selected' : '')}
              key={child.props.panelTitle}
            >
              <h2 className="HorizontalTabPanel__panel-heading">{child.props.panelTitle}</h2>
              {child}
            </div>
          )
        }
      </div>
    </div>
  );
}